export const environment = {
    production: true,
    auth: {
      redirectUri:'https://dev-vts-zeissid-proxy.azurewebsites.net/',
      clientId: 'e0514ed6-d583-42a8-bfb3-635a3c3a8fde',
      issuer: 'https://b2cstage.zeiss.com/483f449b-6a0d-4354-b7e7-37113e7d4ca1/v2.0/',
      discoveryDocument: 'https://id-ip-stage.zeiss.com/B2C_1A_ZeissIdNormalSignIn/OAuth/OpenidConfiguration',
        logOutUri:'https://dev-vts-zeissid-proxy.azurewebsites.net/logout',
    },
    profilePageUrl: 'https://id-stage.zeiss.com/Profile/Index',
    idleTimeout: 36000,
  };
  